<template>
  <img src="/img/payments/visa.png" width="32" height="10" alt="Visa">
</template>
